<template>
  <!-- READ ONLY MODE -->

  <div class="option-section" v-if="mode === 'VIEW'">
    <div class="question-container">
      <span class="step" v-if="showStep">Step {{ question.stepSequence }}</span>
      <p class="question_body ql-editor p-0" v-html="question.formattedBody"></p>
    </div>
    <div class>
      <input type="text" class="input-text readonly" placeholder readonly />
    </div>
  </div>

  <!-- EDIT MODE -->

  <div v-else-if="mode == 'EDIT'">
    <div class="row">
      <div class="col-lg-11 p-0 pb-90">
        <div @click="isAddHelpEnabled = !isAddHelpEnabled" class="th-activity-question-type-custom-scale-edit">
          <span
            class="add-help-text number-add-help-poition-with-score"
            :class="{
              'right-position': activityDetails.customParticipantMessaging
            }"
            :style="{
              color: isAddHelpEnabled ? 'rgba(0, 0, 0, 0.2)' : ''
            }"
          >
            Add Help
          </span>
        </div>
        <div v-if="activityDetails.customParticipantMessaging" class="th-activity-question-type-custom-scale-edit" @click="toggleMessageTextInput">
          <span
            class="add-help-text"
            :style="{
              color: isAddMessageEnabled ? 'rgba(0, 0, 0, 0.2)' : ''
            }"
          >
            Add Message
          </span>
        </div>
        <div>
          <quill-editor class="bg-white mt-30 quill-score" v-model="question.formattedBody" :options="commonProps.editorOptionForQuestion"></quill-editor>
        </div>
      </div>
    </div>
    <!-- help content -->
    <div v-if="isAddHelpEnabled">
      <h5 class="answer">Help</h5>
      <quill-editor class="bg-white mt-40 mb-10" v-model="question.helpContent" :options="editorOptionForHelp" v-on:change="helpCharacterLimitValidation($event)"></quill-editor>
    </div>
    <div v-if="isAddMessageEnabled && activityDetails.customParticipantMessaging" class="row add_message_div mb-30 mt-30">
      <div class="col-md-11 p-0">
        <h5 class="mt-10">Message</h5>
        <quill-editor v-model="question.messageBody" :options="editorOptionForMessage" class="bg-white mb-10 quill-score" @change="helpCharacterLimitValidation"></quill-editor>
      </div>
      <div class="col-md-1 p-0">
        <button class="btn btn-link color_red pl-0 pt-35" @click="toggleMessageTextInput(true)">
          <img src="static/img/delete.svg" />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import activityStepCustomMessage from "@/mixins/activity-step-custom-message";
import { quillEditor } from "vue-quill-editor";

export default {
  name: "ActivityStepNumber",
  mixins: [activityStepCustomMessage],
  components: {
    quillEditor
  },
  props: {
    question: {},
    showStep: { type: Boolean },
    mode: {
      default: "VIEW"
    },
    activityDetails: {},
    commonProps: {},
    editorOptionForHelp: {
      type: Object
    }
  },
  data() {
    return {
      isAddHelpEnabled: false
    };
  },
  watch: {
    isAddHelpEnabled() {
      this.question.isAddHelpEnabled = this.isAddHelpEnabled;
    }
  },
  methods: {
    helpCharacterLimitValidation(event, maxCount = 250) {
      const helpContent = event.quill;
      if (event.text.length > maxCount) {
        this.$toastr.error(`Character limit cannot exceed ${maxCount}.`);
      }
      helpContent.deleteText(maxCount, helpContent.getLength());
    },
    stripHtml(content) {
      const temporalDivElement = document.createElement("div");
      temporalDivElement.innerHTML = content;
      return temporalDivElement.innerText;
    },
    checkQuestionValidity() {
      const question = this.question;
      const errorObj = { isValid: true };

      if (!question.formattedBody || this.stripHtml(question.formattedBody).trim() == "") {
        errorObj.isValid = false;
        errorObj.msg = "Step is required.";
        return errorObj;
      }
      const regEx = "-?[0-9]+(\\.[0-9]{0,3})?";
      const regExWholeNumber = "-?[0-9]+?";
      const regExp = new RegExp(`^${regEx}$`);
      const regExpWholeNumber = new RegExp(`^${regExWholeNumber}$`);
      if (question.characterLimited) {
        if (question.textLimit == null || question.textLimit.length == 0) {
          errorObj.isValid = false;
          errorObj.msg = "Character limit is required.";
          return errorObj;
        } else if (!Number.isInteger(Number(question.textLimit))) {
          errorObj.isValid = false;
          errorObj.msg = "Character limit should be an integer value.";
          return errorObj;
        }
        if (Number(question.textLimit) > 15) {
          errorObj.isValid = false;
          errorObj.msg = "Character limit should not be greater than 15.";
          return errorObj;
        }
        if (Number(question.textLimit) == 0) {
          errorObj.isValid = false;
          errorObj.msg = "Character limit cannot be zero.";
          return errorObj;
        }
      }
      if (question.isAddHelpEnabled && (!question.hasOwnProperty("helpContent") || this.stripHtml(question.helpContent).trim() === "")) {
        errorObj.isValid = false;
        errorObj.msg = "Help text is required for this step.";
        return errorObj;
      }
      if (question.isAddMessageEnabled && (!question.hasOwnProperty("messageBody") || this.stripHtml(question.messageBody).trim() === "")) {
        errorObj.isValid = false;
        errorObj.msg = "Message text is required for this step.";
        return errorObj;
      }
      if (question.allowDecimals) {
        if (question.decimalValue == undefined) {
          errorObj.isValid = false;
          errorObj.msg = "Decimal Places is required.";
          return errorObj;
        } else if (question.decimalValue <= 0) {
          errorObj.isValid = false;
          errorObj.msg = "Decimal places value must be greater than 0.";
          return errorObj;
        } else if (Number(question.decimalValue.toString().length) > 15) {
          errorObj.isValid = false;
          errorObj.msg = "Decimal digits length must not be greater than 15.";
          return errorObj;
        }
      }
      if (question.hasMinMax) {
        if (Number(question.maxValue.toString().length) > 15) {
          errorObj.isValid = false;
          errorObj.msg = "Max value cannot be greater than 15 digits.";
          return errorObj;
        }
        if (question.minValue == undefined || String(question.minValue).length == 0) {
          errorObj.isValid = false;
          errorObj.msg = "Min value is required.";
          return errorObj;
        }
        if (Number(question.minValue.toString().length) > 15) {
          errorObj.isValid = false;
          errorObj.msg = "Min value cannot be greater than 15 digits.";
          return errorObj;
        }
        if (question.maxValue == undefined || String(question.maxValue).length == 0) {
          errorObj.isValid = false;
          errorObj.msg = "Max value is required.";
          return errorObj;
        }
        if (question.allowDecimals) {
          if (!regExp.test(question.minValue) || !regExp.test(question.maxValue)) {
            errorObj.isValid = false;
            errorObj.msg = "Up to 3 decimals are allowed.";
            return errorObj;
          }
        } else {
          if (!regExpWholeNumber.test(question.minValue) || !regExpWholeNumber.test(question.maxValue)) {
            errorObj.isValid = false;
            errorObj.msg = "Decimals are not allowed.";
            return errorObj;
          }
        }
        if (Number(question.minValue) > Number(question.maxValue)) {
          errorObj.isValid = false;
          errorObj.msg = "Min value cannot be greater than Max value.";
          return errorObj;
        }
      }
      if (question.hasSoftMinMax) {
        if (question.softminValue == undefined || String(question.softminValue).length == 0) {
          errorObj.isValid = false;
          errorObj.msg = "Soft min value is required.";
          return errorObj;
        }
        if (Number(question.softminValue.toString().length) > 15) {
          errorObj.isValid = false;
          errorObj.msg = "Soft min value cannot be greater than 15 digits.";
          return errorObj;
        }
        if (question.softmaxValue == undefined || String(question.softmaxValue).length == 0) {
          errorObj.isValid = false;
          errorObj.msg = "Soft max value is required.";
          return errorObj;
        }
        if (Number(question.softmaxValue.toString().length) > 15) {
          errorObj.isValid = false;
          errorObj.msg = "Soft max value cannot be greater than 15 digits.";
          return errorObj;
        }
        if (question.allowDecimals) {
          if (!regExp.test(question.softminValue) || !regExp.test(question.softmaxValue)) {
            errorObj.isValid = false;
            errorObj.msg = "Up to 3 decimals are allowed.";
            return errorObj;
          }
        } else {
          if (!regExpWholeNumber.test(question.softminValue) || !regExpWholeNumber.test(question.softmaxValue)) {
            errorObj.isValid = false;
            errorObj.msg = "Decimals are not allowed.";
            return errorObj;
          }
        }
        if (Number(question.softminValue) > Number(question.softmaxValue)) {
          errorObj.isValid = false;
          errorObj.msg = "Soft Min value cannot be greater Soft Max value.";
          return errorObj;
        }
        if (!question.hasMinMax) {
          errorObj.isValid = false;
          errorObj.msg = "Min/Max value is required.";
          return errorObj;
        } else {
          if (Number(question.minValue) < Number(question.softminValue)) {
            errorObj.isValid = false;
            errorObj.msg = "Min value cannot be less than Soft Min value.";
            return errorObj;
          }
          if (Number(question.maxValue) > Number(question.softmaxValue)) {
            errorObj.isValid = false;
            errorObj.msg = "Max value cannot be greater than Soft Max value.";
            return errorObj;
          }
        }
      }

      if (!question.formattedBody || !question.sequence) {
        errorObj.isValid = false;
        errorObj.msg = "Step is required";
        return errorObj;
      } else if (question.hasUnits && !question.units) {
        errorObj.isValid = false;
        errorObj.msg = "Step is required";
        return errorObj;
      } else if (question.hasMinMax && (question.minValue < 0 || !question.maxValue) && !question.allowNegative) {
        errorObj.isValid = false;
        errorObj.msg = "Step is required";
        return errorObj;
      } else if (question.hasMinMax && question.allowNegative && question.allowDecimals && question.minValue && question.maxValue) {
        errorObj.isValid = true;
        return errorObj;
      } else if (question.hasMinMax && question.allowNegative && (question.allowNegative || question.allowNegative != undefined) && (!question.minValue || !question.maxValue)) {
        errorObj.isValid = false;
        errorObj.msg = "Min/Max value is required.";
        return errorObj;
      } else if (((question.minValue != undefined && question.minValue % 1 !== 0) || (question.minValue != undefined && question.maxValue % 1 !== 0)) && !question.allowDecimals) {
        errorObj.isValid = false;
        errorObj.msg = "Step is required";
        return errorObj;
      } else {
        errorObj.isValid = true;
      }
      return { isValid: true };
    },
    init() {
      if (!this.question.id) {
        this.$set(this.question, "score", 0);
      }
    }
  },
  mounted() {
    this.isAddHelpEnabled = this.question.isAddHelpEnabled;
    this.init();
  }
};
</script>

<style scoped lang="scss">
.radio-option {
  margin: 0px;
  label {
    padding-left: 5px;
  }
}
.integer-plus-minus-input {
  width: 2rem;
  border: none;
  text-align: center;
  // padding-right: 7px;
}
.add-help-text {
  right: 566.5px;
  padding: 12px 13px;

  &.right-position {
    right: 670px;
  }

  @media (min-width: 1600px) {
    right: 576px;

    &.right-position {
      right: 680px;
    }
  }
}
</style>
